export function setUserVars(vars) {
  if (vars) {
    ;(window as any).FS?.setUserVars(vars)
  }
}

export function identifyApplication(appGuid: string) {
  ;(window as any).FS?.identify(appGuid)
}
